import Route from "./Routes/index";
import dayjs from "dayjs";
import "dayjs/locale/tr";
import trTR from "antd/locale/tr_TR";
import { ConfigProvider } from "antd";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PanelEmpty from "./Components/Common/PanelStates";

dayjs.locale("tr");

const kuzemAntTheme = {
 token: {
  colorPrimary: "#0A8F9C",
  colorInfo: "#0A8F9C",
  colorSuccess: "#3FA66A",
  colorError: "#C43B3B",
  colorWarning: "#f1963b",
  colorTextBase: "#14222A",
  colorTextSecondary: "#5B6B73",
  colorBgLayout: "#F4F7F8",
  colorBgContainer: "#FFFFFF",
  colorBgElevated: "#FFFFFF",
  colorBorder: "#E3EAED",
  colorBorderSecondary: "#EEF2F4",
  colorFillAlter: "#F5F9FA",
  borderRadius: 12,
  borderRadiusLG: 18,
  borderRadiusSM: 9,
  fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
  fontSize: 14,
  controlHeight: 40,
  controlHeightLG: 46,
  controlHeightSM: 32,
  wireframe: false,
  motionDurationMid: "0.18s",
  /* Sidebar 1005 / topbar 1002 — modal mask bunların üstünde olmalı */
  zIndexPopupBase: 1200,
 },
 components: {
  Button: {
   primaryShadow: "0 6px 16px rgba(10, 143, 156, 0.28)",
   borderRadius: 12,
   borderRadiusLG: 14,
   fontWeight: 650,
   paddingContentHorizontal: 18,
   controlHeight: 40,
   controlHeightLG: 46,
   defaultBorderColor: "#E3EAED",
   defaultHoverBorderColor: "#0A8F9C",
   defaultHoverColor: "#0B5F6A",
  },
  Table: {
   headerBg: "#EEF5F6",
   headerColor: "#14222A",
   headerSplitColor: "transparent",
   borderColor: "#EEF2F4",
   rowHoverBg: "rgba(10, 143, 156, 0.045)",
   rowSelectedBg: "rgba(10, 143, 156, 0.08)",
   rowSelectedHoverBg: "rgba(10, 143, 156, 0.11)",
   headerBorderRadius: 0,
   cellPaddingBlock: 14,
   cellPaddingInline: 16,
   fontWeightStrong: 700,
  },
  Modal: {
   borderRadiusLG: 20,
   paddingContentHorizontalLG: 24,
   titleFontSize: 20,
   titleLineHeight: 1.3,
  },
  Drawer: {
   paddingLG: 24,
  },
  Card: {
   borderRadiusLG: 18,
   paddingLG: 22,
  },
  Input: {
   borderRadius: 12,
   controlHeight: 40,
   activeBorderColor: "#0A8F9C",
   hoverBorderColor: "#0A8F9C",
   activeShadow: "0 0 0 3px rgba(10, 143, 156, 0.18)",
  },
  Select: {
   borderRadius: 12,
   controlHeight: 40,
   optionSelectedBg: "rgba(10, 143, 156, 0.1)",
  },
  DatePicker: {
   borderRadius: 12,
   controlHeight: 40,
  },
  Menu: {
   itemBorderRadius: 12,
   itemSelectedBg: "rgba(10, 143, 156, 0.12)",
   itemSelectedColor: "#0B5F6A",
   itemHoverBg: "rgba(10, 143, 156, 0.08)",
  },
  Tabs: {
   inkBarColor: "#0A8F9C",
   itemSelectedColor: "#0B5F6A",
   itemHoverColor: "#0A8F9C",
   titleFontSize: 14,
   horizontalItemGutter: 28,
  },
  Collapse: {
   headerBg: "#FFFFFF",
   contentBg: "#FBFCFD",
   borderRadiusLG: 18,
  },
  Tag: {
   borderRadiusSM: 999,
   defaultBg: "rgba(10, 143, 156, 0.1)",
   defaultColor: "#0B5F6A",
  },
  Pagination: {
   borderRadius: 9,
   itemActiveBg: "rgba(10, 143, 156, 0.12)",
  },
  Alert: {
   borderRadiusLG: 14,
  },
  Tooltip: {
   borderRadius: 10,
  },
  Dropdown: {
   borderRadiusLG: 14,
   controlItemBgHover: "rgba(10, 143, 156, 0.08)",
  },
  Segmented: {
   borderRadius: 12,
   borderRadiusSM: 10,
   itemSelectedBg: "#FFFFFF",
   trackBg: "#EEF2F4",
  },
 },
};

const App = () => {
 const location = useLocation();

 useEffect(() => {
  if (window.ym) {
   window.ym("98428588", "hit", location.pathname);
  }
 }, [location]);

 return (
  <>
   <ConfigProvider
    locale={trTR}
    theme={kuzemAntTheme}
    renderEmpty={() => (
     <PanelEmpty
      title="Gösterilecek kayıt yok"
      description="Bu alanda henüz içerik bulunmuyor. Filtreleri kontrol edebilirsin."
     />
    )}
   >
    <Route />
   </ConfigProvider>
  </>
 );
};

export default App;
